import {
    ChangeDetectionStrategy,
    Component,
} from "@angular/core";

@Component({
    selector: "ls-section-box",
    templateUrl: "./section-box.component.html",
    styleUrls: ["./section-box.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
})
export class SectionBoxComponent {
}
